export const darkTheme = {
  token: {
    colorPrimary: '#877689',
    colorBgBase: '#0a0a0a',
    colorBgContainer: '#171717',
    colorBgElevated: '#262626',
    colorBgLayout: '#0a0a0a',
    colorBorder: '#404040',
    colorBorderSecondary: '#262626',
    colorText: '#fafafa',
    colorTextSecondary: '#a3a3a3',
    colorTextTertiary: '#737373',
    colorTextQuaternary: '#525252',
    colorFill: '#262626',
    colorFillSecondary: '#1f1f1f',
    colorFillTertiary: '#171717',
    colorFillQuaternary: '#0a0a0a',
    colorBgSpotlight: '#262626',
    colorError: '#ef4444',
    colorWarning: '#f59e0b',
    colorSuccess: '#22c55e',
    colorInfo: '#3b82f6',
    fontSize: 14,
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
    boxShadowSecondary: '0 2px 8px rgba(0, 0, 0, 0.4)',
  },
  components: {
    Layout: {
      headerBg: '#35292a',
      siderBg: '#0a0a0a',
      bodyBg: '#0a0a0a',
      footerBg: '#35292a',
      triggerBg: '#262626',
      triggerColor: '#fafafa',
    },
    Menu: {
      darkItemBg: '#0a0a0a',
      darkItemSelectedBg: '#262626',
      darkItemHoverBg: '#1f1f1f',
      darkItemColor: '#a3a3a3',
      darkItemSelectedColor: '#877689',
      darkItemHoverColor: '#fafafa',
    },
    Card: {
      colorBgContainer: '#171717',
      colorBorderSecondary: '#262626',
    },
    Table: {
      colorBgContainer: '#171717',
      headerBg: '#262626',
      headerColor: '#fafafa',
      rowHoverBg: '#1f1f1f',
      borderColor: '#404040',
    },
    Input: {
      colorBgContainer: '#171717',
      colorBorder: '#404040',
      colorText: '#fafafa',
      colorTextPlaceholder: '#737373',
      activeBorderColor: '#a855f7',
      hoverBorderColor: '#737373',
    },
    Select: {
      colorBgContainer: '#171717',
      colorBgElevated: '#262626',
      colorBorder: '#404040',
      colorText: '#fafafa',
      optionSelectedBg: '#262626',
      optionActiveBg: '#1f1f1f',
    },
    Button: {
      colorBgContainer: '#171717',
      colorBorder: '#404040',
      colorText: '#fafafa',
      primaryColor: '#fafafa',
      defaultBg: '#262626',
      defaultBorderColor: '#404040',
      defaultColor: '#fafafa',
      defaultHoverBg: '#1f1f1f',
      defaultHoverBorderColor: '#737373',
      defaultHoverColor: '#fafafa',
    },
    Modal: {
      contentBg: '#171717',
      headerBg: '#171717',
      titleColor: '#fafafa',
    },
    Dropdown: {
      colorBgElevated: '#262626',
      controlItemBgHover: '#1f1f1f',
      controlItemBgActive: '#262626',
    },
    Tooltip: {
      colorBgSpotlight: '#262626',
      colorTextLightSolid: '#fafafa',
    },
    Tag: {
      defaultBg: '#262626',
      defaultColor: '#fafafa',
    },
    Alert: {
      colorInfoBg: '#1e3a5f',
      colorInfoBorder: '#3b82f6',
      colorSuccessBg: '#1a3d2e',
      colorSuccessBorder: '#22c55e',
      colorWarningBg: '#4a3a1a',
      colorWarningBorder: '#f59e0b',
      colorErrorBg: '#4a1f1f',
      colorErrorBorder: '#ef4444',
    },
    Segmented: {
      itemSelectedBg: '#262626',
      itemSelectedColor: '#a855f7',
      itemHoverBg: '#1f1f1f',
      itemHoverColor: '#fafafa',
      trackBg: '#171717',
    },
  },
};

export const lightTheme = {
  token: {
    colorPrimary: '#877689',
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#fafafa',
    colorBorder: '#d4d4d4',
    colorBorderSecondary: '#e5e5e5',
    colorText: '#171717',
    colorTextSecondary: '#595959',
    colorTextTertiary: '#737373',
    colorTextQuaternary: '#a3a3a3',
    colorFill: '#f5f5f5',
    colorFillSecondary: '#fafafa',
    colorFillTertiary: '#ffffff',
    colorFillQuaternary: '#ffffff',
    colorBgSpotlight: '#ffffff',
    colorError: '#ef4444',
    colorWarning: '#f59e0b',
    colorSuccess: '#22c55e',
    colorInfo: '#3b82f6',
    fontSize: 14,
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    boxShadowSecondary: '0 1px 4px rgba(0, 0, 0, 0.06)',
  },
  components: {
    Layout: {
      headerBg: '#35292a',
      siderBg: '#fafafa',
      bodyBg: '#fafafa',
      footerBg: '#35292a',
      triggerBg: '#f5f5f5',
      triggerColor: '#171717',
    },
    Menu: {
      itemBg: '#fafafa',
      itemSelectedBg: '#f5f3ff',
      itemHoverBg: '#f5f5f5',
      itemColor: '#595959',
      itemSelectedColor: '#877689',
      itemHoverColor: '#171717',
    },
    Card: {
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#e5e5e5',
    },
    Table: {
      colorBgContainer: '#ffffff',
      headerBg: '#fafafa',
      headerColor: '#171717',
      rowHoverBg: '#f9f9f9',
      borderColor: '#e5e5e5',
    },
    Input: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d4d4d4',
      colorText: '#171717',
      colorTextPlaceholder: '#a3a3a3',
      activeBorderColor: '#9333ea',
      hoverBorderColor: '#a3a3a3',
    },
    Select: {
      colorBgContainer: '#ffffff',
      colorBgElevated: '#ffffff',
      colorBorder: '#d4d4d4',
      colorText: '#171717',
      optionSelectedBg: '#f5f3ff',
      optionActiveBg: '#f9f9f9',
    },
    Button: {
      colorBgContainer: '#ffffff',
      colorBorder: '#d4d4d4',
      colorText: '#171717',
      primaryColor: '#ffffff',
      defaultBg: '#ffffff',
      defaultBorderColor: '#d4d4d4',
      defaultColor: '#171717',
      defaultHoverBg: '#f9f9f9',
      defaultHoverBorderColor: '#a3a3a3',
      defaultHoverColor: '#171717',
    },
    Modal: {
      contentBg: '#ffffff',
      headerBg: '#ffffff',
      titleColor: '#171717',
    },
    Dropdown: {
      colorBgElevated: '#ffffff',
      controlItemBgHover: '#f9f9f9',
      controlItemBgActive: '#f5f3ff',
    },
    Tooltip: {
      colorBgSpotlight: '#262626',
      colorTextLightSolid: '#fafafa',
    },
    Tag: {
      defaultBg: '#f5f5f5',
      defaultColor: '#171717',
    },
    Alert: {
      colorInfoBg: '#eff6ff',
      colorInfoBorder: '#3b82f6',
      colorSuccessBg: '#f0fdf4',
      colorSuccessBorder: '#22c55e',
      colorWarningBg: '#fffbeb',
      colorWarningBorder: '#f59e0b',
      colorErrorBg: '#fef2f2',
      colorErrorBorder: '#ef4444',
    },
    Segmented: {
      itemSelectedBg: '#f5f3ff',
      itemSelectedColor: '#877689',
      itemHoverBg: '#f9f9f9',
      itemHoverColor: '#171717',
      trackBg: '#f5f5f5',
    },
  },
};
